import { ResponseModel } from 'src/app/modules/shared/models/reponse.model';
import { ProductModelDTO, ProductResponseDTO } from '../DTOs/response-dto/products-response-dto';

export class ProductResponseModel extends ResponseModel {
    public _product: ProductModelDTO[];

    public constructor(product: ProductResponseDTO) {
        super(product);
        this._product = product.productModel!;
    }

    public get productCode() : {}[] {
        const productCodeList: { name: string, value: string }[] = [];
        this._product?.forEach(x => {
            productCodeList.push({ name: x?.productCode!, value: x?.productCode! });
        });
        return productCodeList;
    }
}
